import {reducerWithInitialState} from "typescript-fsa-reducers";
import {
    AddSNSLists,
    ClearSNSLists,
    DeleteSNSList,
    DemoAddSNSLists,
    DemoClearSNSLists,
    DemoDeleteSNSList,
    DemoSetSNSLists,
    SetAuthTokenAction,
    SetSNSLists,
    SetUidAction,
    SetUserInfo,
    UpdateErrorSnackBar,
    UpdateSuccessSnackBar,
    HideSnackbar,
} from "../actions";
import {combineReducers} from "redux";
import {LoginResponse, SNSDataList} from "../util/api";

export interface AuthState {
    token: string;
    uid: string;
    userInfo: LoginResponse | null;
}

const AuthInitialState: AuthState = {
    token: "",
    uid: "",
    userInfo: null,
};

const SNSListInitialState: SNSDataList = {
    id: 0,
    snsData: [],
    accounts: [],
};

const Snackbar = {
    isError: false,
    content: "",
};

const auth = reducerWithInitialState(AuthInitialState)
    .case(SetAuthTokenAction, (state, token) => {
        return Object.assign({}, state, {token});
    })
    .case(SetUidAction, (state, uid) => {
        return Object.assign({}, state, {uid});
    })
    .case(SetUserInfo, (state, userInfo) => {
        return Object.assign({}, state, {userInfo});
    });

const snsLists = reducerWithInitialState([SNSListInitialState])
    .case(SetSNSLists, (state, list) => {
        return list;
    })
    .case(ClearSNSLists, () => {
        return [SNSListInitialState];
    })
    .case(AddSNSLists, (state, newList) => {
        const lists = state;
        lists.push(newList);
        return lists;
    })
    .case(DeleteSNSList, (state, listId) => {
        return state.filter((list) => list.id !== listId);
    });

const demoSnsLists = reducerWithInitialState([SNSListInitialState])
    .case(DemoSetSNSLists, (state, list) => {
        return list;
    })
    .case(DemoClearSNSLists, () => {
        return [SNSListInitialState];
    })
    .case(DemoAddSNSLists, (state, newList) => {
        const lists = state;
        lists.push(newList);
        return lists;
    })
    .case(DemoDeleteSNSList, (state, listId) => {
        return state.filter((list) => list.id !== listId);
    });

const snackbar = reducerWithInitialState(Snackbar)
    .case(UpdateSuccessSnackBar, (state, snackbarContent) => {
        return {
            isError: false,
            content: snackbarContent,
        };
    })
    .case(UpdateErrorSnackBar, (state, snackbarContent) => {
        return {
            isError: true,
            content: snackbarContent,
        };
    })
    .case(HideSnackbar, () => {
        return {
            isError: false,
            content: "",
        };
    });
export const reducers = combineReducers({
    auth,
    snsLists,
    demoSnsLists,
    snackbar,
});
